(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    (function() {
    const productDetails = document.querySelector('[data-best-price-variant-id]');
    if (!productDetails) return;
    
    const bestPriceVariantId = productDetails.dataset.bestPriceVariantId;
    if (!bestPriceVariantId) return;
    
    const urlParams = new URLSearchParams(window.location.search);
    const currentVariantParam = urlParams.get('variant');
    
    if (!currentVariantParam) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', bestPriceVariantId);
      window.location.replace(url.toString());
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
